<!DOCTYPE html>
<html>
	<head>
		<title>TypeScript Greeter</title>
		<meta charset="utf-8">
	</head>
	<body>
		<div class="center">
			<div class="margin">
				<div class="container1">
					<div class="border">
					<h2>Ēnu kartes</h2>
					<p class="bigger">
					Ēnu kartes tika veidotas, izmantojot Latvijas Ģeotelpiskās Informācijas Aģentūras nodrošinātos aerolāzerskenēšanas punktus jeb lidara datus, kas parāda pilsētvides trīsdimensionālo struktūru.

					Lidara datu apstrādes rezultātā tika iegūts digitālais virsmas modelis ar telpisko izšķirtspēju

					0.5m uz pikseli, kurš tālāk tika pielietots ēnu projekciju aprēķināšanai.

					Ēnu projekcijas tika iegūtas ar 1 stundas intevālu un apvienotas ēnu kartē.  
					</p>
					<p class="bigger">
					Ēnu karte ir intuitīvi interpretējama sekojoši: jo tumšāks ir attēla apgabals, jo ilgāk dienakts gaišajā laikā

					attiecīgajā apgabalā ir novērojams apēnojums. Attiecīgi, jo gaišāks ir atēla apgabals, jo mazāks apēnojums. 
					</p>
					</div>
				</div>
			</div>
		</div>
	</body>
</html>
